export default __webpack_public_path__ + "static/media/rewards-vip.0bc5b562.png";